import * as i0 from "@angular/core";
export class CanDeactivateGuard {
    canDeactivate(component, currentRoute, currentState, nextState) {
        return component.OnExit ? component.OnExit() : true;
    }
}
CanDeactivateGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanDeactivateGuard_Factory() { return new CanDeactivateGuard(); }, token: CanDeactivateGuard, providedIn: "root" });
